import React from "react";
import PropTypes from "prop-types";
import noImage from "../../../assets/image_not_supported.svg";
import toggleClass from "../../../utils/dom/toggle-class.util";

const GlobalImage = ({ src, alt = "Image", className = "", onError = null, onLoad = null, ...props }) => {
  const handleError = (e) => {
    toggleClass(e.target, "skeleton-loading", false);
    e.target.onerror = null;
    e.target.src = noImage;
    e.target.alt = "Not Available";
    if (onError) {
      onError(e);
    }
  };

  const handleLoad = (e) => {
    toggleClass(e.target, "skeleton-loading", false);
    if (onLoad) {
      onLoad(e);
    }
  };

  return <img src={src} alt={alt} className={`skeleton-loading ${className || ""}`} onError={handleError} onLoad={handleLoad} {...props} />;
};

GlobalImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  ...Object.keys(document.createElement("img").attributes).reduce((acc, attr) => {
    acc[attr.name] = PropTypes.any;
    return acc;
  }, {}),
};

export default GlobalImage;
